import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as PlatformFeeDetailActions from "../../store/actions/PlatformFeeDetailActions";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import PlatformFeeDetailsCard from "../../components/PlatformFeeDetails/PlatformFeeDetailsCard";
import Input from "sushiweb/InputTypes/Input";
import styles from "../../constants/assets/variables";
import * as UserActions from "../../store/actions/User";
import { filterObj, isValidated as isValidatedForMandatoryFields } from "../../utils";
import { ErrorBoundary } from "react-error-boundary";
import BlankState from "../../components/Common/BlankState";

const filterFields = ["driver_id"]
const getInitialState = () => {
    return {
        driver_id: "",
    };
};

const PlatformFeeDetail = ({ platformFeeDetails, activeFilters, getPlatformFeeDetails, setStatus }) => {
    const [initialState, setInitialState] = useState(getInitialState());

    const isValidated = (body) => {
        let hasNoErrors = true;
        let validationState = isValidatedForMandatoryFields(body, Object.keys(initialState));
        if (validationState !== "validated") {
            hasNoErrors = false;
            setStatus({ type: "error", message: "Driver ID is mandatory", });
        }
        return hasNoErrors;
    };

    const handleSubmit = () => {
        let body = filterObj(initialState, filterFields);
        if (!isValidated(body) || activeFilters.driver_id === body.driver_id) return;

        let filters = {};
        for (let key of filterFields) {
            if (body[key] !== "") {
                filters[key] = body[key];
            }
        }
        getPlatformFeeDetails(filters);

    };

    const handleChange = (key, val) => {
        let values = { ...initialState };
        values[key] = val;
        setInitialState(values);
    };

    useEffect(() => {
        //set the initial state of form in modal
        if (Object.keys(activeFilters).length > 0) {
            let values = { ...initialState };
            Object.keys(values).map((key, _) => {
                if (activeFilters[key]) {
                    values[key] = activeFilters[key];
                }
            });
            setInitialState(values);
        }
    }, [activeFilters]);

    return (
        <PlatformFeeDetailsViewContainer>
            <FlexContainer className="mb-20">
                <Heading> Onboarding Fee </Heading>
                <div><Input
                  value={initialState.driver_id}
                  onChange={(e) => handleChange("driver_id", e)}
                  onBlur={handleSubmit}
                  onKeyDown={(event) => {
                      if (event.key === "Enter") handleSubmit();
                  }}
                  id="sushi-input"
                  data-testId="DriverId"
                  label="Driver ID / FE ID"
                  fullWidth={true}
                  required={true}
                  borderColor={styles.primaryColor}
                  autoFocus={true}
                /></div>
            </FlexContainer>
            <PlatformFeeDetailsCardContainer>
                <ErrorBoundary
                  onError={(err) => {console.log(err)}}
                  FallbackComponent={BlankState}>
                    <PlatformFeeDetailsCard data={platformFeeDetails}></PlatformFeeDetailsCard>
                </ErrorBoundary>
            </PlatformFeeDetailsCardContainer>
        </PlatformFeeDetailsViewContainer>
    );
};

const PlatformFeeDetailsViewContainer = styled.section`
    & div > div:nth-child(2) {
        margin-bottom: unset;
    }
`;

const PlatformFeeDetailsCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
`;

function mapStateToProps(state) {
    const { PlatformFeeDetails } = state;
    return {
        platformFeeDetails: PlatformFeeDetails.platformFeeDetails,
        activeFilters: PlatformFeeDetails.activeFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        resetState: () => dispatch(PlatformFeeDetailActions.resetState({})),
        getPlatformFeeDetails: bindActionCreators(
          PlatformFeeDetailActions.getPlatformFeeDetails,
          dispatch
        ),
        setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlatformFeeDetail);
